import { Box, CircularProgress, Typography, keyframes, useTheme } from '@mui/material';

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

interface LoadingProps {
  message?: string;
  fullScreen?: boolean;
}

export function Loading({ message = 'Carregando...', fullScreen = false }: LoadingProps) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  if (fullScreen) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: isDark ? 'rgba(10, 10, 15, 0.95)' : 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(20px)',
          zIndex: 9999,
        }}
      >
        <CircularProgress
          size={56}
          sx={{
            color: '#10b981',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            },
          }}
        />
        {message && (
          <Typography
            variant="body1"
            sx={{
              mt: 3,
              color: isDark ? 'rgba(255, 255, 255, 0.6)' : '#64748b',
              animation: `${pulse} 2s ease-in-out infinite`,
            }}
          >
            {message}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
      }}
    >
      <CircularProgress
        size={48}
        sx={{
          color: '#10b981',
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          },
        }}
      />
      {message && (
        <Typography
          variant="body2"
          sx={{
            mt: 2,
            color: isDark ? 'rgba(255, 255, 255, 0.5)' : '#64748b',
            animation: `${pulse} 2s ease-in-out infinite`,
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
}

export default Loading;
